/** 公共格式校验：正则与 Ant Design Form rules */

/** 大陆手机号：1 开头，第二位 3-9，共 11 位 */
export const MOBILE_REG = /^1[3-9]\d{9}$/;

/** 18 位身份证号（末位可为数字或 X） */
export const ID_CARD_REG =
  /^[1-9]\d{5}(18|19|20)\d{2}(0\d|1[0-2])([0-2]\d|3[0-1])\d{3}(\d|X)$/;

export const MOBILE_RULE = {
  pattern: MOBILE_REG,
  message: '请输入正确的手机号',
};

export const EMAIL_RULE = {
  type: 'email' as const,
  message: '请输入正确格式的邮箱地址',
};

export const ID_CARD_RULE = {
  pattern: ID_CARD_REG,
  message: '请输入正确的身份证号',
};

/** 有值时按身份证格式校验；空值通过（非必填场景） */
export const idCardOptionalValidator = (_: unknown, value?: string) => {
  if (!value) {
    return Promise.resolve();
  }
  if (ID_CARD_REG.test(value)) {
    return Promise.resolve();
  }
  return Promise.reject(new Error('请输入正确的身份证号'));
};

/** 证件类型为身份证（code=1）时校验证件号格式 */
export const createIdCardByIdTypeValidator = (
  getIdType: () => string | undefined,
) => (_: unknown, value?: string) => {
  if (getIdType() !== '1') {
    return Promise.resolve();
  }
  if (!value) {
    return Promise.resolve();
  }
  if (ID_CARD_REG.test(value)) {
    return Promise.resolve();
  }
  return Promise.reject(new Error('请输入正确的身份证号'));
};
